import { createApp } from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag-next";

const app = createApp(App);
app.use(VueGtag, {
	property: {
		id:
			process.env.VUE_APP_MODE === "development" ||
			process.env.VUE_APP_MODE === "staging"
				? "G-YWH7L1F9H4"
				: "G-HB7R2M5S2Q",
	},
});
// vue-router should be put after vue-gtag-next
import router from "./router";
app.use(router).mount("#app");
